export const NAV_ITEMS = ["colores", "características", "dónde comprar"]

export const GLOBAL_SITE_TAG = {
  [process.env.REACT_APP_MX_INSTANCE_ID]: "GTM-NXQCVN2"
}
